/**
 * Title Analyzer
 * Evaluates the blog title for SEO best practices.
 */

export const analyzeTitle = (data) => {
  const { title = "", focusKeyword = "" } = data;
  let score = 0;
  let maxScore = 15;
  const results = [];

  if (!title) {
    return {
      score: 0,
      maxScore,
      results: [{ status: "error", text: "Blog title is missing." }]
    };
  }

  // 1. Title Length (50-60 characters is optimal)
  const len = title.length;
  if (len >= 50 && len <= 60) {
    score += 10;
    results.push({ status: "success", text: `Title length is perfect (${len} characters).` });
  } else if (len > 0 && len < 40) {
    score += 3;
    results.push({ status: "warning", text: `Title is too short (${len} chars). Aim for 50-60 characters.` });
  } else if (len >= 40 && len < 50) {
    score += 7;
    results.push({ status: "warning", text: `Title length is okay (${len} chars), but could be slightly longer.` });
  } else if (len > 60) {
    score += 5;
    results.push({ status: "error", text: `Title is too long (${len} chars). It may be truncated in search results.` });
  }

  // 2. Keyword at the beginning of the title (first 3 words)
  const keyword = (focusKeyword || "").trim().toLowerCase();
  if (keyword) {
    const firstThreeWords = title.split(/\s+/).slice(0, 3).join(" ").toLowerCase();
    if (firstThreeWords.includes(keyword)) {
      score += 5;
      results.push({ status: "success", text: "Focus keyword appears at the beginning of the title." });
    } else {
      results.push({ status: "warning", text: "Try moving the focus keyword closer to the beginning of the title." });
    }
  }

  return { score, maxScore, results };
};
